/* eslint-disable react/no-danger */
import { CSS_SELECTOR, useCustomCss } from '../../contexts/CustomCss';
import { Fragment, FunctionalComponent, h } from 'preact';
import { ShowMore, Text } from './ShowMore.styles';
import { useEffect, useRef, useState } from 'preact/hooks';
import { memo } from 'preact/compat';
import { useDeviceState } from '../../hooks';
import { useUiContext } from '../../contexts/UiContext';

type Props = {
  enableHTMLTextFormatting: boolean;
  isShowMoreEnabled?: boolean;
  labelShowMore?: string;
  longDescription?: string;
  maxDescriptionHeight?: number;
  shortDescription?: string | null;
  withFading?: boolean;
};

const ShowMoreComponent: FunctionalComponent<Props> = memo(
  ({
    enableHTMLTextFormatting = false,
    isShowMoreEnabled = false,
    labelShowMore,
    longDescription,
    maxDescriptionHeight,
    shortDescription,
  }) => {
    const { rules } = useCustomCss(CSS_SELECTOR.DESCRIPTION);
    const { isMobileSmall, isLandscape } = useDeviceState();
    const { setView } = useUiContext();
    const [shouldDisplayShortDescription, displayShortDescription] = useState(isShowMoreEnabled && isMobileSmall);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      displayShortDescription(isShowMoreEnabled && isMobileSmall);
    }, [isLandscape, isMobileSmall, isShowMoreEnabled, setView]);

    return (
      <Fragment>
        {shouldDisplayShortDescription ? (
          <Fragment>
            {shortDescription && shortDescription !== '' && (
              <Text maxHeight={maxDescriptionHeight}>
                {enableHTMLTextFormatting ? (
                  <div dangerouslySetInnerHTML={{ __html: shortDescription || '' }} />
                ) : (
                  shortDescription
                )}
              </Text>
            )}
            <ShowMore
              onClick={(): void => displayShortDescription(!shouldDisplayShortDescription)}
              data-testid="uc-show-more"
            >
              {`${labelShowMore}...`}
            </ShowMore>
          </Fragment>
        ) : (
          <Fragment>
            {longDescription && longDescription !== '' && (
              <Text maxHeight={maxDescriptionHeight} ref={textRef} style={{ ...rules }}>
                {enableHTMLTextFormatting ? (
                  <div dangerouslySetInnerHTML={{ __html: longDescription || '' }} />
                ) : (
                  longDescription
                )}
              </Text>
            )}
          </Fragment>
        )}
      </Fragment>
    );
  },
);

export default ShowMoreComponent;
